export default {"src":"/_next/static/media/chart-mixed-up-circle-dollar-classic-solid.87050e14.svg","height":24,"width":24};